import { mapActions, mapGetters } from 'vuex';

import FillStatusSummary from '@/components/rabbit/fill-status-summary/FillStatusSummary.vue';
import _ from 'lodash';
import { initDycolor } from '~';

initDycolor('landing-page', require(`${process.env.DYCOLOR_REQUIRE}./LandingPage.scss`)); // eslint-disable-line

const CUSTOM_LANDING = 'custom-landing';
const ADD_CUSTOM_LANDING = 'add-landing-page';

// Copied from Agent (CampaignSettings component)
const validateUrl = value => {
  const expression = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\/.*)?$/;
  this.invalidUrl = false;
  return Boolean(value && value.match(expression) !== null);
};

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      internalCustomPageLink: null,
      internalLandingPageType: null,
      internalSelected: null,
      selectedType: null,
      ADD_CUSTOM_LANDING,
    };
  },
  components: {
    'fill-status-summary': FillStatusSummary,
  },
  methods: {
    ...mapActions('campaign', ['setLandingPage']),
    showModal() {
      // Set current Landing page
      if (this.currentCampaignLandingPage) {
        this.internalLandingPageType = this.currentCampaignLandingPage.name;
        this.internalSelected = this.currentCampaignLandingPage.link;
      } else {
        this.internalLandingPageType = CUSTOM_LANDING;
      }

      this.$refs.landingPageModal.show();
    },
    changeInternalLandingPageType(value) {
      if (value === CUSTOM_LANDING) {
        this.internalSelected = ADD_CUSTOM_LANDING;
      } else {
        this.internalSelected = null;
      }
    },
    cancel() {
      this.$refs.landingPageModal.hide();
    },
    saveLandingPage(e) {
      e.preventDefault();
      if (this.internalCustomPageLink.includes('play.google.com') || this.internalCustomPageLink.includes('itunes.apple.com')) {
        this.$toast.error({ message: this.$t('pos.campaign.creatives.adv-builder.incorrect-url') });
        return;
      }
      this.loading = true;

      const selectedPage = this.pageExists();
      const newPage = {
        landingpageId: selectedPage ? selectedPage.id : 0,
        landingpageLink:
          this.internalSelected === ADD_CUSTOM_LANDING
            ? this.internalCustomPageLink
            : this.internalSelected,
        landingpageType: this.internalLandingPageType,
        landingpageIdOld: _.get(this.currentCampaignLandingPage, 'id', 0),
      };

      this.setLandingPage(newPage)
        .then(() => {
          this.loading = false;
          this.$toast.success({ message: this.$t('pos.campaign.landing-page-updated') });
          this.cancel();
        })
        .catch(error => {
          this.loading = false;
          this.$toast.error({ message: String(error) });
        });
    },
    pageExists() {
      return this.customerLandingPages.find(
        page => page.name === this.internalLandingPageType && page.link === this.internalSelected,
      );
    },
  },
  computed: {
    ...mapGetters('campaign', {
      campaign: 'currentCampaign',
    }),
    currentCampaignLandingPage() {
      // Set first one, as we allow only one landing page
      return _.get(this.campaign, 'landingpages.[0]', null);
    },
    customerLandingPages() {
      return _.get(this.campaign, 'customer.landingpages', []);
    },
    availableLandingPageTypes() {
      const unique = new Set(this.customerLandingPages.map(item => item.name));
      unique.add(CUSTOM_LANDING); // We need this every time
      return [...unique];
    },
    availableLandingPages() {
      const pages = this.customerLandingPages
        .filter(page => page.name === this.internalLandingPageType)
        .map(page => ({
          value: page.link,
          text: page.link,
        }));

      // Allow user to add new custom landing page
      if (this.internalLandingPageType === CUSTOM_LANDING) {
        pages.push({
          value: ADD_CUSTOM_LANDING,
          text: this.$t('pos.campaign.add-landing-page'),
        });
      }
      return pages;
    },
    canSaveLandingPage() {
      const validCustomLandingPage =
        this.internalLandingPageType === CUSTOM_LANDING &&
        this.internalSelected === ADD_CUSTOM_LANDING &&
        validateUrl(this.internalCustomPageLink);

      return validCustomLandingPage || !!this.pageExists();
    },
    readyForCAP() {
      return _.get(this.campaign, 'ready_for_cap.landing_page', false);
    },
    userInterfaceLink() {
      if (!this.currentCampaignLandingPage) {
        return '';
      }

      return this.currentCampaignLandingPage.link.replace(/^.*?\/\/(?:www\.)/, '');
    },
  },
  mounted() {
    if (this.currentCampaignLandingPage) {
      this.internalLandingPageType = this.currentCampaignLandingPage.name;
      this.internalSelected = this.currentCampaignLandingPage.link;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/landing-page/LandingPage.js